import { FiArrowUpRight, FiShield } from "react-icons/fi";
import { Link } from "react-router-dom";
import { section1Data } from "../../../../data/neurofeed";
import classes from "./Section1.module.css";
import sectionImage from "./neurofeedback_section1.webp";

const badgeContent = {
  icon: FiShield,
  label: "Advanced Support",
  text: "Neurofeedback-based care",
};

export default function Section1() {
  const BadgeIcon = badgeContent.icon;

  return (
    <section className={classes.section}>
      <div className={`container ${classes.container}`}>
        <div className={classes.layout}>
          <div className={classes.visual}>
            <div className={classes.imageWrap}>
              <img
                src={sectionImage}
                alt="Neurofeedback services and cognitive support"
                className={classes.image}
                loading="lazy"
                decoding="async"
              />

              <div className={classes.visualBadge}>
                <span className={classes.badgeIcon} aria-hidden="true">
                  <BadgeIcon />
                </span>

                <span className={classes.badgeContent}>
                  <strong>{badgeContent.label}</strong>
                  <small>{badgeContent.text}</small>
                </span>

                <span className={classes.badgeArrow} aria-hidden="true">
                  <FiArrowUpRight />
                </span>
              </div>
            </div>
          </div>

          <div className={classes.content}>
            <div className={classes.eyebrow}>
              <span className={classes.eyebrowLine} aria-hidden="true" />
              Additional
            </div>

            <h2 className={classes.title}>
              Neurofeedback{" "}
              <span className={classes.titleAccent}>Services</span>
            </h2>

            <p className={classes.intro}>
              Expand your care capabilities with specialized neurofeedback
              services designed to support cognitive performance, memory, and
              overall brain health.
            </p>

            <div className={classes.services}>
              {section1Data.map((service) => {
                const Icon = service.icon;

                return (
                  <Link
                    key={service.title}
                    to={service.link}
                    className={classes.card}
                    aria-label={`View ${service.title}`}
                  >
                    <div className={classes.cardTop}>
                      <span className={classes.iconBox} aria-hidden="true">
                        <Icon />
                      </span>

                      <div className={classes.cardHeading}>
                        <h2>{service.title}</h2>
                        <span>{service.subtitle}</span>
                      </div>
                    </div>

                    <p className={classes.description}>{service.description}</p>
                  </Link>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
